import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";

import TelegramBackButton from "../../components/TelegramBackButton.jsx";
import NoResult from "../../assets/inbox_empty.png";
import defaultImage from "../../assets/default.png";
import SearchHouse from "../../components/SearchHouse";
import Trending from "../Trending/Trending";
import { Link } from "react-router-dom";
import { API_BASE_URL, API_KEY } from "../../config.js";
import LoadingAnim from "../../components/LoadingAnim";
import LazyLoad from "react-lazyload";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import "../../App.css";
import "./CategoryList.css";

const ITEMS_PER_PAGE = 10;

const CategoryList = () => {
  const { t } = useTranslation();
  const isHomePage = false;

  const [filteredProperties, setFilteredProperties] = useState([]);
  const { catagory } = useParams();
  const [properties, setProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
   const [trendingDataExists, setTrendingDataExists] = useState(false);

  const fetchProperties = useCallback(
    async (page) => {
      setIsLoading(true);
      try {
        const initData = window.Telegram.WebApp.initData;
        const response = await fetch(
          `${API_BASE_URL}/user/api/v1/properties/?catagory=${catagory}&page=${page}&page_size=${ITEMS_PER_PAGE}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": API_KEY,
              "X-Telegram-InitData": initData,
            },
          }
        );

        const data = await response.json();

        const totalItems = data.count;
        setTotalPages(Math.ceil(totalItems / ITEMS_PER_PAGE));

        const transformedProperties = data.results.map((house) => ({
          id: house.id,
          title: house?.houses[0]?.title || "Untitled",
          city: house.houses[0]?.city || "Unknown",
          tumble_image: house.tumble_image || defaultImage,
          postedBy: house.userAccount?.first_name || "Unknown",
          houseProperty: [house],
        }));

        setProperties((prevProperties) =>
          page === 1
            ? transformedProperties
            : [...prevProperties, ...transformedProperties]
        );

        setFilteredProperties((prevProperties) =>
          page === 1
            ? transformedProperties
            : [...prevProperties, ...transformedProperties]
        );
      } catch (error) {
        console.error("Failed to fetch properties:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [catagory]
  ); // Depend only on `catagory`

  useEffect(() => {
    setProperties([]);
    setPage(1);
    fetchProperties(1); // Fetch initial properties
  }, [catagory, fetchProperties]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        if (!isLoading && page < totalPages) {
          setPage((prevPage) => prevPage + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isLoading, page, totalPages]);

  useEffect(() => {
    if (page > 1) {
      fetchProperties(page);
    }
  }, [page, fetchProperties]);

  // API Search Function
  const fetchSearchResults = async (query) => {
    if (query.trim() === "") {
      setFilteredProperties(properties);
      return;
    }

    setIsLoading(true);
    try {
      const initData = window.Telegram.WebApp.initData;
      const response = await fetch(
        `${API_BASE_URL}/user/api/v1/houses/search/?query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": API_KEY,
            "X-Telegram-InitData": initData,
          },
        }
      );

      const data = await response.json();
      console.log("data ", data);

      const transformedProperties = data.results.map((house) => ({
        id: house.id,
        title: house?.houses[0]?.title || "Untitled",
        city: house.houses[0]?.city || "Unknown",
        tumble_image: house.tumble_image || defaultImage,
        postedBy: house.userAccount?.first_name || "Unknown",
        houseProperty: [house],
      }));

      setFilteredProperties(transformedProperties);
    } catch (error) {
      console.error("Search request failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const debouncedSearch = useCallback(debounce(fetchSearchResults, 500), []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    debouncedSearch(term);
  };

  return (
    <>
      <TelegramBackButton isHomePage={isHomePage} />
      <br />

      <SearchHouse onFilter={handleSearch} />

      {searchTerm === "" && trendingDataExists && (
        <div>
          <h1 className="text-sm font-bold mb-4 text-left px-6">
            {t("Most Popular")}
          </h1>
          <Trending setTrendingDataExists={setTrendingDataExists} />
        </div>
      )}

      <div className="p-4">
        {/* <h3 className="text-sm font-bold">{t("Nearby Your Location")}</h3> */}
        {isLoading && page === 1 ? (
          <LoadingAnim />
        ) : filteredProperties.length > 0 ? (
          filteredProperties.map((property) => (
            <div
              key={property.id}
              className="property-item rounded-lg overflow-hidden bg-white mb-6"
            >
              <Link
                to={`/GroupLists/${property.id}`}
                className="block"
                state={{ houses: property.houseProperty }}
              >
                <div className="property-image w-full">
                  {property.tumble_image ? (
                    <LazyLoad height={350} offset={100}>
                      <img
                        src={property.tumble_image}
                        alt="Property"
                        className="w-full"
                        style={{ borderRadius: "15px", height: "320px" }}
                      />
                    </LazyLoad>
                  ) : (
                    <img
                      src={defaultImage}
                      alt={property.title}
                      className="w-full"
                      style={{ borderRadius: "15px", height: "320px" }}
                    />
                  )}
                </div>

                <div className="p-1">
                  <div className="flex justify-between items-center">
                    <h3 className="text-md font-bold truncate">
                      {property.title || "No title available"}
                    </h3>
                    <div className="flex items-center">
                      <i
                        className="fa fa-star"
                        style={{ color: "#FFA500" }}
                      ></i>
                      <span className="text-xs text-gray-500">4.0/5.0</span>
                    </div>
                  </div>

                  <p className="text-xs text-gray-500">
                    {t("List all Amities")}
                  </p>
                  <p className="text-xs text-gray-500 mt-1">
                    {t("Posted by")}

                    <b>{property.postedBy}</b>
                  </p>

                  <div className="flex justify-between mt-1">
                    {property.city && (
                      <p className="text-xs text-gray-500 flex items-center">
                        <i className="fa fa-map-marker mr-1"></i>
                        {property.city}
                      </p>
                    )}
                    <p className="text-xs font-bold text-blue-500">
                      {t("See all details")}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center text-center px-4 sm:px-0">
            <div className="flex flex-col justify-center items-center">
              <img
                src={NoResult}
                alt="no result found"
                className="mb-4 w-40 sm:w-22 md:w-30 lg:w-34 xl:w-32"
              />
            </div>
          </div>
        )}
        {isLoading && page > 1 && <LoadingAnim />}
        {/* Show loading animation when loading more properties */}
      </div>
    </>
  );
};

export default CategoryList;